// eslint-disable-next-line import/prefer-default-export
export const showOnlineConsultModal = () => {
    window.moinWidget.exec('form', 'show');
};
